import { amexAdapter as amex } from './amex'
import { discoverAdapter as discover } from './discover'
import { mastercardAdapter as mastercard } from './mastercard'
import { visaAdapter as visa } from './visa'
import { aggregatorAdapter as aggregator } from './aggregator'

export const sdkAdapters = {
  mastercard,
  visa,
  amex,
  discover,
  aggregator
}
